<i class="material-icons" *ngIf="matIcon">{{ matIcon }}</i>
<hf-inject-svg *ngIf="svgIconUrl" [src]="svgIconUrl"></hf-inject-svg>
